import request from "./ConfigRequest";

export const pageDenormalizedSettlementTransactionDto = (index, size)=>{
    return request({
        url: 'denormalizedSettlementTransaction/pageDenormalizedSettlementTransactionDto',
        params: {
            index,
            size,
        },
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    });
};


export const saveDenormalizedSettlementTransaction = (denormalizedSettlementTransactionDto)=>{
    return request({
        url: 'denormalizedSettlementTransaction/saveDenormalizedSettlementTransactionDto',
        method: 'post',
        data: denormalizedSettlementTransactionDto,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};


export const updateDenormalizedSettlementTransactionDto = (denormalizedSettlementTransactionDto)=>{
    return request({
        url: 'denormalizedSettlementTransaction/updateDenormalizedSettlementTransactionDto',
        method: 'put',
        data: denormalizedSettlementTransactionDto,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};


export const searchDenormalizedSettlementTransactionDto = (index, size, id)=>{
    return request({
        url: 'denormalizedSettlementTransaction/pageDenormalizedSettlementTransactionDto',
        params: {
            index,
            size,
            id,
        },
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    });
};
